import styled from 'styled-components';
import { lightGrey1Color, blueColor, lightGrey3Color } from 'js/config/style';
import { upTo } from 'js/services/MediaQuery';

import { breakpoint } from './Grid';
import { height } from './DashPanel/Header';

const radiusSize = '0.25rem';
const borderColor = lightGrey1Color.darken(0.5);

export default styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-row-gap: 0.5rem;
  grid-column-gap: 0.5rem;
  border-radius: ${radiusSize} 0 0 ${radiusSize};
  padding: ${height} 0 3rem;
  user-select: none;

  & > a {
    padding: 0 1rem;
    line-height: 3rem;
    display: block;
    font-weight: 500;
    background: white;
    border-radius: ${radiusSize} 0 0 ${radiusSize};
    border: 1px solid ${borderColor};
    border-width: 1px 0 1px 1px;
    position: relative;
    right: -10px;
    transition: all 0.2s ease;
    color: ${lightGrey3Color};

    &:hover,
    &:focus,
    &.active {
      background: ${blueColor};
      color: white;
      text-decoration: none;
      border: 1px solid ${borderColor};
      border-width: 1px 0 1px 1px;
      right: 0px;
    }
  }

  ${upTo(breakpoint)`
    display: none;
  `}
`;
